//Instalados
import React, { useRef, useCallback, useEffect, useState } from "react";
import { Form } from "@unform/web";
import * as Yup from "yup";
import getValidationErrors from "../../utils/getValidationErrors";
import { FormHandles } from "@unform/core";
import axsLogo from "../Images/AxsLogo.svg";
import { useAPI } from "../../hooks/contextApis";
import { writeStorage } from "../../utils/storage/storage";
import version from "../../../package.json";
import ModalLogin from "../Modais/ModalLogin";
import WhatsAppCodeModal from "../Modais/WppDialog";
import api from "../../services/api/index";
import check from "../../components/Toast/Image/check.svg";
import error from "../../components/Toast/Image/error.svg";
import { useProgress } from "../../hooks/progress";

//Próprios
import "./css/MasterLogin.css";
import "./css/MasterLoginMobile.css";
import { Input } from "../Inputs/Input";
import { IDataLogin } from "../../@Types";

window.onload = function () {
  localStorage.removeItem("@ARP-adesao");
  localStorage.removeItem("@ARP-economia");
  localStorage.removeItem("@ARP-home");
  localStorage.removeItem("@ARP-beneficios");
  localStorage.removeItem("@ARP-card");
  localStorage.removeItem("@ARP-holderdata");
  localStorage.removeItem("@ARP-filldata");
  localStorage.removeItem("@ARP-consumo");
  localStorage.removeItem("@ARP-commercial");
  localStorage.removeItem("@ARP-modalCheck");
  localStorage.removeItem("@ARP-login");
  localStorage.removeItem("@ARP-dados");
  localStorage.removeItem("@ARP-paginacao");
  sessionStorage.removeItem("@ARP-Energia:token");
};

window.onload = function () {
  localStorage.removeItem("@AXS-adesao");
  localStorage.removeItem("@AXS-economia");
  localStorage.removeItem("@AXS-home");
  localStorage.removeItem("@AXS-beneficios");
  localStorage.removeItem("@AXS-card");
  localStorage.removeItem("@AXS-holderdata");
  localStorage.removeItem("@AXS-filldata");
  localStorage.removeItem("@AXS-consumo");
  localStorage.removeItem("@AXS-commercial");
  localStorage.removeItem("@AXS-modalCheck");
  localStorage.removeItem("@AXS-login");
  localStorage.removeItem("@AXS-dados");
  localStorage.removeItem("@AXS-paginacao");
  sessionStorage.removeItem("@AXS-Energia:token");
};

export default function TelaLoginNew() {
  const useFormRef = useRef<FormHandles>(null);
  const {
    signIn,
    checkVersion,
    openModal,
    setOpenModal,
    openModalWpp,
    setOpenModalWpp,
    setEmailSessao,
    setChaveSessao,
  } = useAPI();
  const { isLoad, setLoad } = useProgress();

  const [email, setEmail] = useState("");
  const [loginData, setLoginData] = useState<IDataLogin | null>(null);
  const [erroCodigoWpp, setErroCodigo] = useState(false);
  const [list, setList] = useState<any>([]);

  const closeModal = () => {
    setOpenModal(false);
  };

  const handleRememberPassword = () => {
    window.location.href = "/arp/rememberpassword";
  };

  const getVersion = useCallback(() => {
    setTimeout(() => {
      checkVersion();
    }, 2000);
  }, [checkVersion]);

  useEffect(() => {
    writeStorage({
      key: "appVersion",
      object: {
        versionStorage: version.version,
      },
    });
    getVersion();
  }, [getVersion]);

  const dataSend = useCallback((data) => {
    const dataLogin: IDataLogin = {
      email: data.email,
      senha: data.senha,
    };

    return dataLogin;
  }, []);

  const handleSubmit = useCallback(
    async (data) => {
      try {
        useFormRef.current?.setErrors({});

        const basicValidation = Yup.object().shape({
          email: Yup.string().required("Informe o E-mail"),
          senha: Yup.string().required("Informe a senha"),
        });

        await basicValidation.validate(data, { abortEarly: false });

        const sendData = dataSend(data);

        const response = await signIn(sendData);

        console.log(response);
        setLoginData(sendData);
        setEmail(data.email);
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          useFormRef.current?.setErrors(errors);
        }
      }
    },
    [dataSend, signIn]
  );

  useEffect(() => {
    localStorage.removeItem("@ARP-adesao");
    localStorage.removeItem("@ARP-economia");
    localStorage.removeItem("@ARP-home");
    localStorage.removeItem("@ARP-beneficios");
    localStorage.removeItem("@ARP-card");
    localStorage.removeItem("@ARP-holderdata");
    localStorage.removeItem("@ARP-filldata");
    localStorage.removeItem("@ARP-consumo");
    localStorage.removeItem("@ARP-commercial");
    localStorage.removeItem("@ARP-modalCheck");
    localStorage.removeItem("@ARP-login");
    localStorage.removeItem("@ARP-dados");
    localStorage.removeItem("@ARP-paginacao");
    sessionStorage.removeItem("@ARP-Energia:token");

    localStorage.removeItem("@AXS-adesao");
    localStorage.removeItem("@AXS-economia");
    localStorage.removeItem("@AXS-home");
    localStorage.removeItem("@AXS-beneficios");
    localStorage.removeItem("@AXS-card");
    localStorage.removeItem("@AXS-holderdata");
    localStorage.removeItem("@AXS-filldata");
    localStorage.removeItem("@AXS-consumo");
    localStorage.removeItem("@AXS-commercial");
    localStorage.removeItem("@AXS-modalCheck");
    localStorage.removeItem("@AXS-login");
    localStorage.removeItem("@AXS-dados");
    localStorage.removeItem("@AXS-paginacao");
    sessionStorage.removeItem("@AXS-Energia:token");
  }, []);

  const handleClose = () => {
    setErroCodigo(false);
    setOpenModalWpp(false);
  };

  let toastProperties: {
    id: number;
    title: string;
    description: string;
    backgroundColor: string;
    icon: any;
  } | null = null;
  //eslint-disable-next-line
  const showToast = (type: any) => {
    const id = Math.floor(Math.random() * 101 + 1);

    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: "",
          description: "Login efetuado com sucesso",
          backgroundColor: "#5cb85c",
          icon: check,
        };
        break;
      case "primeiro":
        toastProperties = {
          id,
          title: "",
          description: "Primeiro acesso?",
          backgroundColor: "#f0ad4e",
          icon: check,
        };
        break;
      case "warning":
        toastProperties = {
          id,
          title: "",
          description: "Erro ao efetuar login",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "email":
        toastProperties = {
          id,
          title: "",
          description: "Usuário inexistente",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "senhaErrada":
        toastProperties = {
          id,
          title: "",
          description: "Senha incorreta",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "cadastre":
        toastProperties = {
          id,
          title: "",
          description: "Cadastre sua senha...",
          backgroundColor: "#f0ad4e",
          icon: check,
        };
        break;
      case "semEquipe":
        toastProperties = {
          id,
          title: "",
          description: "Coordenador sem equipe vinculada",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "redirect":
        toastProperties = {
          id,
          title: "",
          description: "Redirecionando...",
          backgroundColor: "#f0ad4e",
          icon: check,
        };
        break;
      case "404":
        toastProperties = {
          id,
          title: "",
          description: "Sem propostas encontradas",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "403":
        toastProperties = {
          id,
          title: "",
          description: "Acesso não autorizado",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "inativo":
        toastProperties = {
          id,
          title: "",
          description: "Login não autorizado",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      default:
        setList([]);
    }
    setList([...list, toastProperties]);
  };

  const setDadosLogin = useCallback(
    async ({ id }) => {
      api.defaults.headers.common = {
        Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
      };
      setLoad(true);
      await api.get(`/csp/representante/cards/consultar?idCard=${id}`)
        .then((res) => {
          const removeItem = (arr: any, refId: any) => {
            return arr.filter(function (i: any) {
              return i.situa_o_arp !== refId;
            });
          };
          const arr = removeItem(res.data["cards"], "inativo");
          if (res.status === 200) {
            setLoad(false);
            writeStorage({
              key: "dados",
              object: {
                Cards: arr,
              },
            });

            showToast("success");
            setTimeout(function () {
              showToast("redirect");
            }, 1000);

            setTimeout(function () {
              setLoad(false);
              window.location.href = "/arp/";
            }, 3000);
          }
        })
        .catch((error) => {
          setLoad(false);
          if (error.response.status === 403) {
            //showToast('403')
            setLoad(false);
          }
          if (error.response.status === 404) {
            const arr = error.response.data["cards"];

            writeStorage({
              key: "dados",
              object: {
                Cards: arr,
              },
            });

            showToast("success");
            setTimeout(function () {
              showToast("redirect");
            }, 1000);

            setTimeout(function () {
              setLoad(false);
              window.location.href = "/arp/";
            }, 3000);
          }
          if (error.response.status === 500) {
            //showToast('500')
            setLoad(false);
          }
        });
    },
    [setLoad, showToast]
  );

  return (
    <>
      <ModalLogin isOpen={openModal} onRequestClose={closeModal} />
      <WhatsAppCodeModal
        open={openModalWpp}
        erroCodigo={erroCodigoWpp}
        onClose={() => handleClose()}
        onConfirm={async (code: string) => {
          try {
            const response = await api.post(
              "/csp/representante/verificarCodigoWpp",
              {
                email,
                codigoWpp: code,
              }
            );
            writeStorage({
              key: "paginacao",
              object: {
                pageIndex: 0,
                pageSize: 10,
              },
            });
            if (response.data["retorno"] === "OK") {
              const token = response.data.acessToken;
              sessionStorage.setItem("@ARP-Energia:token", token);

              writeStorage({
                key: "login",
                object: {
                  NomeRepresentante: response.data.informacao["nome"],
                  EmailRepresentante: response.data.informacao["e_mail"],
                  CpfRepresentante: response.data.informacao["cpf"],
                  RazaoRepresentante: response.data.informacao["raz_o_social"],
                  CnpjRepresentante: response.data.informacao["cnpj"],
                  TipoVendedor: response.data.informacao["tipo"],
                  CodigoLink:
                    response.data.informacao[
                      "c_digo_do_link_verificar_com_a_bplus"
                    ],
                  canal: response.data.informacao["canal"],
                  Meta: response.data.informacao["meta_do_m_s_1"],
                  Grupo: response.data.informacao["grupo"],
                  Gestor1: response.data.informacao["gerente_respons_vel"],
                  Gestor2:
                    response.data.informacao[
                      "executivo_supervisor_respons_vel"
                    ],
                  Gestor3: response.data.informacao["gestor_3"],
                  Origem: response.data.informacao["origem"],
                  CodigoPlano:
                    response.data.informacao["plano_que_est_vendendo"],
                  Equipe: response.data.informacao["equipe_1"],
                  Regional: response.data.informacao["regional"],
                  IdCard: response.data.informacao["idCard"],
                },
              });

              setDadosLogin({ id: response.data.informacao["idCard"] });
            }
            if (response.data.retorno === "sessao ativa") {
              setOpenModalWpp(false);
              setOpenModal(true);
              setEmailSessao(email);
              setChaveSessao(response.data.chaveVerificaSessao);
            }
            if (response.data.retorno === "codigo diferente") {
              setErroCodigo(true);
              setEmailSessao(email);
              setChaveSessao(response.data.chaveVerificaSessao);
              return;
            }
          } catch (error) {
            console.error("Código incorreto ou erro na verificação", error);
          }
        }}
        onResendCode={async () => {
          if (loginData) {
            try {
              await signIn(loginData); // reaproveita o login
            } catch (err) {
              console.error("Erro ao reenviar código");
            }
          }
        }}
      />
      <div className="GridLogin ">
        <div className="DivMotivation">
          <br />
          <br />

          <div className="DivTextMotivation">
            <div className="Conic">
              <span className="Aspas"></span>
            </div>
            O segredo do sucesso é a constância do propósito.
            <div className="DivAutorMotivation">Benjamin Disraeli</div>
          </div>
        </div>
        <div className="DivInputs">
          <img className="imgLog" src={axsLogo} alt="" />
          <div className="DivTextInputs">Bem vindo, representante!</div>
          <div className="DivSecondTextInputs">
            Pronto para vender muito? 🚀
          </div>
          <br />
          <div className="Inputs">
            <Form ref={useFormRef} onSubmit={handleSubmit}>
              <Input
                type="text"
                id="inputEmailLoginARP"
                name="email"
                placeholder="E-mail"
                className="form-control"
                style={{
                  width: "100%",
                  backgroundColor: "#f5f5f5",
                  border: "none",
                }}
              />
              <Input
                type="password"
                id="inputSenhaLoginARP"
                name="senha"
                placeholder="Senha"
                className="form-control"
                style={{
                  width: "100%",
                  backgroundColor: "#f5f5f5",
                  border: "none",
                }}
              />
              <button type="submit" id="btnLoginARP" className="btnPurple">
                Entrar
              </button>
            </Form>
            <br />
            <div className="DivTerceTextInputs">
              <span
                className="DivTextPurple"
                style={{ cursor: "pointer" }}
                onClick={handleRememberPassword}
              >
                Esqueci minha senha
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
